// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"83b0ce07","46":"21578f95","73":"5a0743da","228":"7a20f69c","354":"a53dbd7f","397":"c62a94c0","418":"be1ec616","507":"fa775941","780":"e2b4319e","914":"c5925051","925":"3f014d3a"}[chunkId] + ".chunk.js";
};